"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = exports.Loader = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
const Loader = ({ children, text, isBlocking = false, size, visible = true, className }) => {
    const classNames = css("loader", { "-overlay": isBlocking, className }, `-${size}`);
    return (React.createElement(React.Fragment, null,
        visible && (React.createElement("span", { className: classNames, "data-test": "loader" }, text && React.createElement("span", { className: css("loader_content") }, text))),
        children));
};
exports.Loader = Loader;
const LoadingOverlay = (_a) => {
    var { size = "lg" } = _a, rest = __rest(_a, ["size"]);
    return React.createElement(exports.Loader, Object.assign({ isBlocking: true }, rest, { size: size }));
};
exports.LoadingOverlay = LoadingOverlay;
//# sourceMappingURL=index.js.map